"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var lodash_1 = require("lodash");
var Text_1 = __importDefault(require("shared/components/Text"));
var formatters_1 = require("utils/formatters");
var StatusCounter = function (_a) {
    var value = _a.value;
    var total = (0, lodash_1.sum)(Object.values(value));
    if (value.accepted) {
        return ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, lineHeight: "38px", color: "riverstone" }, { children: "".concat((0, formatters_1.formatPercentPrecise)((value.accepted / total)), " Accepted (").concat(value.accepted, "/").concat(total, ")") })));
    }
    return null;
};
exports.default = StatusCounter;
